import React, {Component} from 'react';
import * as Yup from 'yup';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {FormField} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {RouteComponentProps} from "react-router";
import {inject, observer} from "mobx-react";
import {Button, Typography} from "@material-ui/core";
import AlertDialog from "../../components/Dialog/alertDialog";
import {IMenuStore} from "../../mobx-store/storeInterfaces/menuStoreInterface";


interface IProps {
    menuStore: IMenuStore;
}

interface IState {
    formFields: FormField[];
    processing: boolean;
    loading: boolean;
    isDialogOpen: boolean;
}

@inject('menuStore')
@observer
class AddEditCategory extends Component<IProps & RouteComponentProps<{
    categoryId: string
}>, IState> {
    isNew: boolean = false;
    submitButton: any;
    cancelButton: any;
    TeamSchema: any;
    categoryId: any;
    pageTitle = '';

    constructor(props: IProps & RouteComponentProps<{
        categoryId: string
    }>) {
        super(props);
        if (this.props.match.params.categoryId) {
            this.isNew = false;
            this.categoryId = this.props.match.params.categoryId;
            this.pageTitle = 'Edit Category';
        } else {
            this.isNew = true;
            this.pageTitle = 'Add Category';
        }
        this.initTeamSchema();
        this.initState();
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
    }

    initTeamSchema = () => {
        this.TeamSchema = Yup.object().shape({
            categoryName: Yup.string().required('Required'),
            categoryImage: Yup.array()
                .min(1, 'You need to Add at Least one image')
                .max(1, 'You only need to Add one Image')
                .required('Required'),
            brands: Yup.array()
                .min(1, 'You need to Add at Least one image')
                .required('Required'),
        });
    };

    getSubmitButton = () => {
        return {
            title: (this.isNew ? 'Add' : 'Save Changes'),
            onSubmit: this.handelSubmit,
        };
    }

    getCancelButton = () => {
        return {
            title: 'Cancel',
            onCancel: this.navigateBack,
        };
    };

    navigateBack = () => {
        this.props.history.goBack();
    };

    handelSubmit = async (values: any) => {
        this.setState({processing: true});
        if (this.isNew) {
            await this.props.menuStore.addCategory(values);
        } else {
            await this.props.menuStore.editCategory(this.categoryId, values);
        }
        this.navigateBack();
        this.setState({processing: false});
    };
    initState = () => {
        this.state = {
            isDialogOpen: false,
            processing: false,
            loading: false,
            formFields: [
                {
                    name: 'categoryName',
                    label: 'Category Name',
                    type: 'text',
                    filedType: 'InputField',
                },
                {
                    name: 'categoryImage',
                    label: 'Category Image',
                    type: 'text',
                    filedType: 'GalleryField',
                    value: [],
                    accept: 'png',
                    isLimitToOneImage: true,
                },
                {
                    name: 'brands',
                    label: 'Brands',
                    selectListKey: 'brandId',
                    selectListValue: 'brandName',
                    filedType: 'MultipleSelectField',
                },
            ]
        };
    };
    updateStateWithTeamData = (currentCategory: any) => {
        const formFieldsWithData = [];
        for (let field of this.state.formFields) {
            if (field.name === 'categoryImage') {
                currentCategory[field.name] = [{imageUrl: currentCategory[field.name]}];
            }
            formFieldsWithData.push(Object.assign({}, field, {value: currentCategory[field.name]}));
        }
        this.setState({formFields: formFieldsWithData, processing: false, loading: false});
    };

    async componentDidMount() {
        this.props.menuStore.mapCategoriesItemsBrands();
        if (!this.isNew) {
            this.setState({loading: true});
            await this.props.menuStore.getCategoryById(this.categoryId).then(snapshot => {
                this.updateStateWithTeamData(snapshot.val());
            }).catch(() => {
                this.setState({loading: false});
            });

        }
    }

    handleDelete = async () => {
        this.setState({isDialogOpen: true});
    };
    handleAgree = async () => {
        await this.props.menuStore.deleteCategory(this.categoryId);
        this.navigateBack();
    };
    handleClose = () => {
        this.setState({isDialogOpen: false});
    };

    render() {
        const {loaded, brands} = this.props.menuStore;
        if (loaded) {
            const formFields = this.state.formFields.map(field => {
                if (field.name === 'brands') {
                    return {...field, selectList: brands}
                } else {
                    return field;
                }
            });
            return (
                <div>
                    {this.state.loading ?
                        <Typography variant='h6' gutterBottom>Loading</Typography>
                        : <GeneralFormComponent
                            formTitle={this.pageTitle}
                            fields={formFields}
                            formSchema={this.TeamSchema}
                            submitButton={this.submitButton}
                            cancelButton={this.cancelButton}
                            processing={this.state.processing}
                        />
                    }
                    {/*{*/}
                    {/*    this.isNew ? null : <Button*/}
                    {/*        onClick={this.handleDelete}*/}
                    {/*        variant='contained'*/}
                    {/*        type='button'*/}
                    {/*        style={{fontSize: '14px',fontWeight:'bold'}}*/}
                    {/*        color='secondary'>*/}
                    {/*        Delete*/}
                    {/*    </Button>*/}
                    {/*}*/}
                    {
                        <AlertDialog isOpen={this.state.isDialogOpen}
                                     title='Delete Category'
                                     content='All items for this category will be deleted. Are You Sure You want to Delete This Category?'
                                     buttonText='ok'
                                     agree={this.handleAgree}
                                     disAgree={this.handleClose}
                                     hasActions={true}
                        />
                    }
                </div>
            );
        } else
            return null;
    }
}

export default AddEditCategory;